//
// Initialize plugins and behaviors on document ready
//

$(function (){

    masonry.init()

    navbar.init()

    AOS.init()

    switchButton.init()

    infobulle.init()

    buttonCard.init()

    swiper.init()

    modalAcess.init()

    voletContent.init()

    bntReturn.init()

    sidebarNav.init()

    spinButton.init()

})


var masonry = {
    init: function(){
        $('.grid').masonry({
            transitionDuration: 0,
            itemSelector: ".grid-item",
            fitWidth: true,
            gutter: 10
        });
    }
}

//
// Add extra behavior to the navbar
//

var navbar = {
    init: function () {
        if (!window.utils.isMobile()) {
            this.initDropdownHover()
        }
    },
    // show/hide dropdown on hover
    initDropdownHover: function () {
        var $dropdowns = $('.navbar .dropdown')
        $dropdowns.each(function (index, item) {
            var $item = $(this)

            $item.hover(function () {
                $item.addClass("show")
                $item.find("> .dropdown-toggle").attr("aria-expanded", true)
                $item.find("> .dropdown-menu").addClass("show")
            }, function () {
                $item.removeClass('show')
                $item.find("> .dropdown-toggle").attr("aria-expanded", false)
                $item.find("> .dropdown-menu").removeClass("show")
            })
        })
    },

}


//
// Extra Helpers
//

window.utils = {
    isMobile: function () {
        if (window.innerWidth <= 992) {
            return true
        } else {
            return false
        }
    }
}

//
// cartes de choix
//

var buttonCard = {
    init: function () {
        $('.a-btnCard').click( function () {
            $(this).toggleClass('');
        })
    }
}

//
// Switch button
//

var switchButton = {

    init: function () {
        $('.a-switch').click(function (evt) {

            let el = evt.target;

            if (el.getAttribute("aria-checked") == "true") {
                el.setAttribute("aria-checked", "false");
            } else {
                el.setAttribute("aria-checked", "true");
            }

        })
    }
}




//
// disparition de l'infobulle au clic sur le bouton de fermeture
//

var infobulle = {
    init: function () {
        $('.closeInfobulle').click(function () {
            $('.m-infobulle').hide(200);
        })
    }
}


//
// swiper
//

var swiper = {
    init: function () {
        $("[data-toggle='swiper']").each(function(index, item) {
            new Swiper(item, $(item).data('options'))
        })
    }
}


//
// switch focus  between close & button - forbidden focus to the container of modal
//
var modalAcess = {
    init: function () {
        $(document).ready(function () {
//            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').on('shown.bs.modal', function () {
//                $('.getFocus').trigger('focus');
//            });
//            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').focus(function () {
//                $('.getFocus').trigger('focus');
//            });
        	$('.modal').on('shown.bs.modal', function () {
                $('.getFocus').trigger('focus');
            });
            $('.modal').focus(function () {
                $('.getFocus').trigger('focus');
            });
        })
    }
}


//
// Volet button
//

var voletContent = {
    init: function () {

    var countTime = 0;
    var header = $('.o-voletContent');
    if(!header.hasClass("visible")) {
        var TimeInterval = setInterval(function() {
            ++countTime;
            header.toggleClass('visible');
            if(countTime >= 2){
                clearInterval(TimeInterval);
            }
        }, 5000);
    }
        $('.a-btn.-languette').on('click', function () {
            $('.o-voletContent').toggleClass('visible');
            if($('.o-voletContent').hasClass('visible')) {
                $('.o-voletContent__boxText').show();
                $('.o-voletContent__closeButton').show();                
                $(this).attr("aria-expanded", "true");
            } else {
                $(this).attr("aria-expanded", "false");
                setTimeout(function() {
                    $('.o-voletContent__boxText').hide();
                    $('.o-voletContent__closeButton').hide();
                }, 500);
            }
            
        })
        $('.a-btn.getCloseHelp').on('click', function () {
            $('.o-voletContent').removeClass('visible');
            $('.a-btn.-languette').attr("aria-expanded", "false");
            setTimeout(function() {
                $('.o-voletContent__boxText').hide();
                $('.o-voletContent__closeButton').hide();
            }, 500);
            
        })
    }
}


var bntReturn = {
    init: function () {
        $(document).ready(function () {
            $("[id*='return']").click(function(event) {
                event.preventDefault();
                window.location.href = "${backURL}";
            });
        })
    }
}

var sidebarNav = {
    init: function(){
        $('.sidebarNavOpen').on('click', function(){
            $('.m-sidebarNav').addClass('active');
            $('.overlay').addClass('active');

            $('html').addClass('overflow-hidden');
        })

        $('.sidebarNavClose, .overlay').on('click', function(){
            $('.m-sidebarNav').removeClass('active');
            $('.overlay').removeClass('active');

            $('html').removeClass('overflow-hidden');
        })
    }
}

var spinButton = {
    init: function(){
        /** @type {!Element} The input element. */
        let inputEl;
        /** @type {!Element} The button up element. */
        let incrementButtonEl;
        /** @type {!Element} The button down element. */
        let decrementButtonEl;
  
        /** @type {number} The value as a number. */
        let valueNumber;
        /** @type {string} The string value of the input. */
        let valueText;
  
        /** @type {number} Constant representing aria-valuemax. */
        let MIN_VALUE;
        /** @type {number} Constant representing aria-valuemin. */
        let MAX_VALUE;
        /** @type {number} Constant representing the initial aria-valuenow. */
        let INITIAL_VALUE;
        /** @type {number} Constant representing increment/decrement size. */
        let STEP_SIZE;
  
        function init() {
          inputEl = document.getElementById('input-spin-size');
          incrementButtonEl = document.getElementById('increment');
          decrementButtonEl = document.getElementById('decrement');
          MIN_VALUE = Number(inputEl.getAttribute('aria-valuemin'));
          MAX_VALUE = Number(inputEl.getAttribute('aria-valuemax'));
          valueNumber = Number(inputEl.getAttribute('aria-valuenow'));
          valueText = inputEl.value;
          INITIAL_VALUE = valueNumber;
          STEP_SIZE = 1;
          setEventListeners();
        }
  
        function setEventListeners() {
          inputEl.addEventListener('input', handleInputInput, false);
          inputEl.addEventListener('keydown', handleInputKeyDown, false);
          incrementButtonEl.addEventListener('click', handleIncrementButtonClick, false);
          decrementButtonEl.addEventListener('click', handleDecrementButtonClick, false);
        }
  
        function handleIncrementButtonClick(e) {
          increment();
          inputEl.focus();
        }
  
  
        function handleDecrementButtonClick(e) {0
          decrement();
          inputEl.focus();
        }
  
        /**
        * Sets input field to default upon blur of the empty input.
        * Sets value to default if value is no longer valid.
        * Otherwise truncates value and updates aria-valuenow.
        * @param {!Event} e
        */
        function handleInputInput(e) {
          if (!input.value || input.value === '-' || input.value === '.') {
            // clear the value.
            inputEl.setAttribute('aria-valuenow', '');
            valueNumber = null;
            valueText = input.value;
            return;
          }
          let newValueNumber = Number(input.value);
          if (isNaN(newValueNumber)) {
            input.value = valueText;
          } else {
            // Note that this will set an invalid aria-valuenow.
            // Bug tracking how and when to modify aria-valuenow:
            // https://github.com/w3c/aria-practices/issues/704
            setValue(newValueNumber);
          }
        }
  
        /**
        * Switch that handles all valid non-numerical key downs.
        * @param {!Event} e
        */
        function handleInputKeyDown(e) {
          switch (e.key) {
            case 'ArrowUp':
              increment();
              break;
            case 'ArrowDown':
              decrement();
              break;
            case 'Home':
              setValue(MIN_VALUE);
              break;
            case 'End':
              setValue(MAX_VALUE);
              break;
            default:
              return;
          }
          e.preventDefault();
          e.stopPropagation();
        }
  
        // add jsdoc
        function increment() {
          if (valueNumber >= MAX_VALUE) {
            setValue(MAX_VALUE);
          } else if (valueNumber < MIN_VALUE) {
            setValue(MIN_VALUE);
          } else {
            setValue(valueNumber + STEP_SIZE)
          }
        }
  
        // add jsdoc
        function decrement() {
          if (valueNumber <= MIN_VALUE) {
            setValue(MIN_VALUE);
          } else if (valueNumber > MAX_VALUE) {
            setValue(MAX_VALUE);
          } else {
            setValue(valueNumber - STEP_SIZE)
          }
        }
  
        /**
        * Sets value property and aria-valuenow attribute together.
        * @param {number} newValue
        */
        function setValue(newValue) {
          inputEl.value = newValue;
          inputEl.setAttribute('aria-valuenow', newValue);
          valueNumber = newValue;
          valueText = inputEl.value;
        }
  
  
        window.addEventListener('load', init, false);
    }
}

